export const COMPONENT_NAME = 'MediaGallery';
